import React, { Component, useContext, useEffect, useState } from 'react'
import styles from './FoolScreen.module.scss'
import fullScreenIcon from '../../../img/icons/fullScreen.png'
import { Controllers } from '../Controllers/Controllers'
import { Tooltip } from '../Tooltip/Tooltip'
import videoActive from '../../../img/icons/video-stream-active.png'
import videoNotActive from '../../../img/icons/video-stream-not-active.png'
import voiceActive from '../../../img/icons/voice-active.png'
import voiceNotActive from '../../../img/icons/voiceNotActive.png'
import { VideoComponent } from '../../LivekitComponents'
import { MainContext } from '../../../utils/context'



export const FoolScreen = () => {
  
  const {foolScreen, closeFoolScreen} = useContext(MainContext)
  
  const [firstTrack, setFirstTrack] = useState(null)
  const [secondTrack, setSecondTrack] = useState(null)
  
  useEffect(() => {
    if (!foolScreen) return;
    const { videoTrack, screenShareTrack } = foolScreen
    setFirstTrack(screenShareTrack || videoTrack)
    setSecondTrack(screenShareTrack ? videoTrack : null)
  }, [foolScreen])
  

  
  
  
  if (!foolScreen) return null

  return (
    <div className={styles.foolScreen}>
      <VideoComponent track={firstTrack}/>
      {secondTrack &&
        <div className={styles.secondScreenBlock}>
        <VideoComponent track={secondTrack}/>
      </div>}
      <img src={fullScreenIcon} alt="o_O" onClick={closeFoolScreen} />
      {/* <div className={styles.controllers}>
        <Tooltip content='микрофон'>
          <img
            src={true ? voiceActive : voiceNotActive}
            alt="o_O"
            // onClick={togglePublishAudio}
          />
        </Tooltip>
        <Tooltip content='камера'>
          <img
            src={true ? videoActive : videoNotActive}
            alt="o_O"
            // onClick={togglePublishVideo}
          />
        </Tooltip>
      </div> */}
    </div>
  )
}
